if (!customElements.get('dual-swatch-selector')) {
  class DualSwatchSelector extends HTMLElement {
    constructor() {
      super();
      this.nativeSelect = this.querySelector('select');
      this.customSelect = this.querySelector('custom-select');
      this.shadeButtons = this.querySelectorAll('.js-change-shade');
      this.swatchRadios = this.querySelectorAll('input[type="radio"].js-option');
      this.urlShade = DualSwatchSelector.getUrlParam('shade');
      this.isSiblingSelector = this.closest('.product-options__siblings');

      if (this.isSiblingSelector) {
        this.customSelect?.addEventListener('change', this.handleSiblingChange.bind(this));
      } else {
        this.nativeSelect?.addEventListener('change', this.handleSelectChange.bind(this));
      }

      this.swatchRadios.forEach((swatchRadio) => {
        swatchRadio.addEventListener('change', this.handleRadioChange.bind(this));
      });

      this.shadeButtons.forEach((shadeButton) => {
        shadeButton.addEventListener('click', this.handleShadeChange.bind(this));
        if (this.urlShade?.toLowerCase() === shadeButton.dataset.selectedShade?.toLowerCase()) {
          shadeButton.click();
        }
      });
    }

    handleSiblingChange(evt) {
      const productRelativeUrl = evt.detail.selectedValue.match(/\/products\/.*$/)[0];
      const link = this.querySelector(`a[href$="${CSS.escape(productRelativeUrl)}"]`);
      if (link) {
        link.closest('preload-links[active]')?.prepareLink(link);
        link.click();
      } else if (evt.detail.selectedValue) {
        window.location.href = evt.detail.selectedValue;
      }
    }

    handleSelectChange(evt) {
      // Trigger a click event on the corresponding swatch value
      this.querySelector(`input[value="${CSS.escape(evt.target.value)}"]`)?.click();
    }

    handleRadioChange(evt) {
      if (evt.target.checked) {
        const customSelectOption = this.customSelect?.querySelector(`li[data-value="${CSS.escape(evt.target.value)}"]`);
        if (customSelectOption) {
          this.customSelect.selectOption(customSelectOption);
        }
      }
    }

    static updateURLWithShade(shade) {
      if (!Shopify.designMode) {
        const url = new URL(window.location);
        url.searchParams.set('shade', shade);
        window.history.replaceState({}, '', url);
      }
    }

    static getUrlParam(param) {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(param);
    }

    static setParamInHref(href, param, value) {
      const url = new URL(href, window.location.origin);

      if (value !== '') {
        url.searchParams.set(param, value);
      } else {
        url.searchParams.delete(param);
      }

      return url.toString();
    }

    handleShadeChange(evt) {
      if (!this.dataset.featuredProduct) {
        DualSwatchSelector.updateURLWithShade(evt.target.dataset.selectedShade);
      }

      // Change the active button
      this.shadeButtons.forEach((shadeButton) => {
        shadeButton.classList.toggle('font-bold', evt.target === shadeButton);
      });

      // Hide the relevant shades
      this.querySelectorAll('[data-shade]').forEach((elem) => {
        elem.hidden = elem.dataset.shade !== evt.target.dataset.selectedShade && evt.target.dataset.selectedShade !== '';

        if (this.isSiblingSelector && elem.tagName === 'A' && !this.dataset.featuredProduct) {
          elem.href = DualSwatchSelector.setParamInHref(elem.href, 'shade', evt.target.dataset.selectedShade);
        } else if (this.isSiblingSelector && elem.classList.contains('custom-select__option') && !this.dataset.featuredProduct) {
          elem.dataset.value = DualSwatchSelector.setParamInHref(elem.dataset.value, 'shade', evt.target.dataset.selectedShade);
        }
      });

      // Select the first swatch from the group
      let foundVisibleSwatch = false;
      this.swatchRadios.forEach((radio) => {
        if (!foundVisibleSwatch && !radio.hasAttribute('hidden')) {
          radio.click();
          foundVisibleSwatch = true;
        }
      });
    }
  }

  customElements.define('dual-swatch-selector', DualSwatchSelector);
}
